import { render, staticRenderFns } from "./urban-tower-extension.vue?vue&type=template&id=1f12ab7a&"
import script from "./urban-tower-extension.vue?vue&type=script&lang=js&"
export * from "./urban-tower-extension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports